<template>
  <div class="optimize-main model suggest">
    <!--    <div class="suggest-title" @click="show = !show">-->
    <!--      <span>简历优化建议<b>（{{totalCount}}）</b></span>-->
    <!--      <i class="icon-right iconfont iconchevron-down" :class="[show ? 'active' : '']"></i>-->
    <!--    </div>-->
    <!-- <div :class="['optimize-content', show ? 'show' : '']" :style="{height: hasJobscanRepor ? '340px' : '492px'}"> -->
    <div :class="['optimize-content', show ? 'show' : '']" :style="{height: (show && !hasJobscanRepor && !isMentorEditor && cvDetail.basic_info.lang === 'cn') ? '572px' : '682px'}">

<!--      <div class="buy-member-tips" v-if="!isMembership" @click.stop.prevent="buyMember">-->
<!--        <img src="@/assets/image/cv-editer-member.png" />-->
<!--        <span>会员展示详细优化建议</span>-->
<!--      </div>-->
      <!-- 满分简历不再展示优化建议 -->
      <div class="full-score-container" v-if="readyScore === 100">
        <img src="https://files.wondercv.com/cv-check/check-100.png" alt="">
        <p>Wow，这是一份无懈可击的简历！</p>
      </div>


      <!-- 优化建议 -->
      <div class="suggest-content pr" v-else>

        <!-- 简历纠错-->
        <div class="suggest-item" :class="[openResumeError?'resume-error-active':'']" v-show="cvDetail.basic_info.lang === 'cn' && !cvDetail.basic_info.kind && !isMentorEditor">
          <div class="suggest-name">
            <div class="suggest-name-left">
              <img class="check-logo" src="https://files.wondercv.com/cv-check/resume-error-correction.png" alt="">
              <span>简历纠错</span>
            </div>
            <div class="suggest-name-right f_12">
              <template v-if="openResumeError">
                <div class="error-name-tips">纠错模式已开启</div>
                <div class="error-name-close text_center" @click.stop="showCloseCvErrorTips=true">退出</div>
              </template>
              <div class="error-name-button text_center" v-else @click="checkCvErrors()">立即纠错</div>
            </div>
          </div>
          <div class="check-content no-circle" :class="{'hidden': !openResumeError}">
            <div class="resume-error-content" >
              <div class="head-content flex-c">
                <div class="title flex1">{{getFilterErrorInfoSize.allLength ? `发现 ${getFilterErrorInfoSize.allLength} 处疑似错误` : '暂未发现疑似错误'}}</div>
                <div class="button text_center color_fff f_14" @click="checkCvErrors()">
                  <span class="iconfont iconsousuo1"></span>重新纠错
                </div>
              </div>
              <div class="list flex-c text_center">
                <div class="item flex1" :class="[resumeErrorFilterType==='word' ? 'active' : '']" @click="changeResumeErrorCorrection('word')">
                  <div class="number f_20 font_w_b">{{getFilterErrorInfoSize.word.length}}</div>
                  <div class="text color_60">字句错误</div>
                </div>
                <div class="item flex1" :class="[resumeErrorFilterType==='punc' ? 'active' : '']" @click="changeResumeErrorCorrection('punc')">
                  <div class="number f_20 font_w_b">{{getFilterErrorInfoSize.punc.length}}</div>
                  <div class="text color_60">标点错误</div>
                </div>
                <div class="item flex1" :class="[resumeErrorFilterType==='miss' ? 'active' : '']" @click="changeResumeErrorCorrection('miss')">
                  <div class="number f_20 font_w_b">{{getFilterErrorInfoSize.miss.length}}</div>
                  <div class="text color_60">语法错误</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 模拟面试 -->
        <div class="suggest-item" v-show="cvDetail.basic_info.lang === 'cn'">
          <div class="suggest-name">
            <div class="suggest-name-left">
              <img class="check-logo" src="https://files.wondercv.com/cv-check/resume-mock-interview.png" alt="">
              <span>模拟面试</span>
              <img class="label-image" src="https://logo.wondercv.com/banners/OZdR75lqRtxnXTb.jpg" alt="">
              <!-- <img class="bate-icon" src="https://files.wondercv.com/cv-check/resume-mock-interview-beta.png" alt=""> -->
            </div>
            <div class="suggest-name-right f_12">
              <div class="error-name-button text_center" @click.stop="checkMockInterview()">立即查看</div>
              <!-- no-right-button -->
              <!-- <i class="iconfont iconchevron-down" :class="{'icon-active': mockInterviewActive}"></i> -->
            </div>
          </div>
          <div class="check-content" :class="[mockInterviewList.length || mockInterviewNotData || !!mockInterviewLoadingText ? '' : 'hidden', ]">
            <!-- 加载中 -->
            <div class="suggest-list suggest-loading delete-pointer" v-if="!!mockInterviewLoadingText">
              <span class="loading-text">
                <i class="el-icon-loading"></i>
                {{mockInterviewLoadingText}}
              </span>
            </div>
            <!-- 无数据 -->
            <div class="suggest-list delete-pointer" v-else-if="mockInterviewNotData">
              <span class="suggest-text">AI开小差了，没有生成面试问题</span>
            </div>
            <!-- 数据渲染 -->
            <template v-else>
              <div class="suggest-list delete-pointer" v-for="(item, index) in mockInterviewList" :key="index">
                <span class="suggest-text">{{item}}</span>
              </div>
              <div class="suggest-list" @click="toService()">
                <div class="suggest-text-placeholder">
                  <img src="@/assets/image/examination-placeholder.png" />
                  <div class="mock-interview-button">看看面试官怎么问</div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <template v-for="(item, index) in suggestFields">
          <div class="suggest-item" :key="index">

            <div class="suggest-name" @click="toggleStatus(item)">

              <div class="suggest-name-left">
                <img class="check-logo" :src="item.img" alt="">
                <span>{{ item.title }}</span>
              </div>

              <!-- <template v-if="item.field === 'analyse'">
                <div class="suggest-name-right" :class="{'spacing': checkData[item.field] && checkData[item.field].length}">
                  <span v-if="cvRisksLength">{{ cvRisksLength }}项</span>
                  <span v-else class="perfect"><i class="iconfont iconwanmei"></i>完美</span>
                  <i class="iconfont iconchevron-down" :class="{'icon-active': item.active}"></i>
                </div>
              </template> -->
              <template v-if="item.field === 'analyse'">
                <div class="suggest-name-right f_12">
                  <div class="error-name-button text_center">立即查看</div>
                </div>
              </template>
              <template v-else>
                <div class="suggest-name-right" :class="{'spacing': checkData[item.field] && checkData[item.field].length}">
                  <span v-if="checkData[item.field] && checkData[item.field].length">{{ checkData[item.field].length }}项待修改</span>
                  <span v-else class="perfect"><i class="iconfont iconwanmei"></i>完美</span>
                  <i class="iconfont iconchevron-down" :class="{'icon-active': item.active}"></i>
                </div>
              </template>

            </div>

            <!--其他模块-->
            <ul class="check-content" :ref="`${item.field}&checkContent`" :class="{'hidden': !item.active}" v-if="item.field !== 'analyse'">
              <!-- 有优化建议时 展示优化建议 -->
              <template v-if="checkData[item.field] && checkData[item.field].length">
                <li class="suggest-list" v-for="(issues, num) in checkData[item.field]" :key="num"
                    @click.stop="!isMembership ? buyMember() : suggestDetail(issues, item)">
                  <div class="suggest-text-placeholder" v-if="!isMembership">
                    <img src="@/assets/image/examination-placeholder.png" />
                  </div>
                  <template v-else>
                    <span class="suggest-text" :class="{'advice-change': issues.hasChange}">{{ issues.desc }}</span>
                    <i class="iconfont iconwenhao" v-if="issues.article_url" @click.stop="nothing">
                      <div class="article-tooltip-container">
                        <div class="article-tooltip-content">
                          <a @click="toBlogDetail($event)" class="article-content" :href="issues.article_url" target="_blank">{{ issues.article_title }}</a>
                          <div class="comments-container" v-if="issues.comments && issues.comments.length" @click.stop="changeDownloadAppState">
                            <template v-for="(item, index) in issues.comments">
                              <div :key="index" class="article-comment-item">
                                <div class="comment-info flex-start">
                                  <img :src="item.avatar_url" alt="">
                                  <span class="name">{{ item.name }}</span>
                                  <span class="community-identity">{{ item.community_identity }}</span>
                                </div>
                                <div class="comment">{{ item.comment }}</div>
                              </div>
                            </template>
                          </div>
                          <div v-if="issues.comment_count" class="view-more-count" @click.stop="changeDownloadAppState">查看全部{{ issues.comment_count }}条讨论</div>
                        </div>
                      </div>
                    </i>
                  </template>
  <!--                <el-tooltip class="check-item" placement="bottom-start" popper-class="article-tooltip-container" v-if="issues.article_title">-->
  <!--                  <a slot="content" class="article-content" :href="issues.article_url" target="_blank">{{ issues.article_title }}</a>-->
  <!--                </el-tooltip>-->
                </li>
              </template>
              <!-- 没有优化建议时 显示固定文本 -->
              <li v-else class="suggest-list perfect-text">
                <span class="suggest-text">{{ item.perfectText }}</span>
              </li>
            </ul>

            <template v-if="item.field === 'analyse' && !cvPortrait.cv_highlights.length && !cvPortrait.cv_risks.length && !cvPortrait.skills.length">
              <ul class="check-content" :ref="`${item.field}&checkContent`" :class="{'hidden': !item.active}">
                <li class="suggest-list perfect-text">
                  <span class="suggest-text">{{ item.perfectText }}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              <!--others模块的简历画像(亮点)-->
              <ul class="check-content cv-portrait-container high-light" :class="{'hidden': !item.active}" v-if="item.field === 'analyse' && cvPortrait.cv_highlights.length">
                <div class="module-title">
                  <i class="iconjianliliangdian iconfont"/>
                  <span>简历亮点</span>
                </div>
                <img class="opacity-img" src="https://files.wondercv.com/PC/editor/spotlight.png" alt="">
                <li class="suggest-list cv-portrait-item" v-for="(issues, num) in cvPortrait.cv_highlights" :key="num">
                  <span class="">{{ issues }}</span>
                </li>
              </ul>
              <!--others模块的简历画像(风险)-->
              <ul class="check-content cv-portrait-container risks" :class="{'hidden': !item.active}" v-if="item.field === 'analyse' && cvPortrait.cv_risks.length">
                <div class="module-title">
                  <i class="iconjianlifengxian iconfont"/>
                  <span>简历风险</span>
                </div>
                <img class="opacity-img" src="https://files.wondercv.com/PC/editor/risk.png" alt="">
                <li class="suggest-list cv-portrait-item" v-for="(issues, num) in cvPortrait.cv_risks" :key="num">
                  <span class="">{{ issues }}</span>
                </li>
              </ul>
              <!--others模块的简历画像(技能关键词)-->
              <ul class="check-content cv-portrait-container skills" :class="{'hidden': !item.active}" v-if="item.field === 'analyse' && cvPortrait.skills.length">
                <div class="module-title">
                  <i class="iconjinengguanjianci iconfont"/>
                  <span>技能关键词</span>
                </div>
                <img class="opacity-img" src="https://files.wondercv.com/PC/editor/skills.png" alt="">
                <div class="skill-container">
                  <div class="skill-item" v-for="(item, index) in cvPortrait.skills" :key="index">{{item}}</div>
                </div>
              </ul>
            </template>
          </div>
        </template>

        <!-- 简历认证 -->
        <div class="suggest-item" v-show="!cvDetail.format_info.watermark">
          <div class="suggest-name" @click="cvModuleActive = !cvModuleActive">
            <div class="suggest-name-left">
              <img class="check-logo" src="https://files.wondercv.com/cv-check/cv.png" alt="">
              <span>简历认证</span>
            </div>
            <div class="suggest-name-right">
              <span>未认证</span>
              <i class="iconfont iconchevron-down" :class="{'icon-active': cvModuleActive}"></i>
            </div>
          </div>
          <ul class="check-content" :class="{'hidden': !cvModuleActive}">
            <li class="suggest-list" @click.stop="setEditorMenuTipsType('textFormat')">
              <span class="suggest-text">添加简历认证标识，超级简历联合大厂HR为你的简历质量背书</span>
            </li>
          </ul>
        </div>

        <!-- 简历推荐 -->
        <div class="suggest-item" v-show="!cvDetail.format_info.watermark">
          <div class="suggest-name" @click="resumeRecommend = !resumeRecommend">
            <div class="suggest-name-left">
              <img class="check-logo" src="https://files.wondercv.com/cv-check/recommend.png" alt="">
              <span>简历推荐</span>
            </div>
            <div class="suggest-name-right">
              <span v-if="privacy && !privacy.recommend_for_hr">未推荐</span>
              <span v-else class="perfect"><i class="iconfont iconwanmei"></i>已推荐</span>
              <i class="iconfont iconchevron-down" :class="{'icon-active': resumeRecommend}"></i>
            </div>
          </div>
          <div class="check-content no-circle" :class="{'hidden': !resumeRecommend}">
            <div class="suggest-list" >
              <a href="/account/users?index=2" target="_blank">
                <span class="suggest-text color_40">设置简历推荐，让offer找到你</span>
              </a>
            </div>
          </div>
        </div>


        <!-- 纠错模式下，功能不可用 -->
        <div class="open-resume-error-cover-up" v-show="openResumeError" @click.stop="showCloseResumeError()"></div>

      </div>

      <!-- APP 下载二维码 -->
      <!-- <div class="guide-code-container flex-center" :class="{'full-score-code': readyScore === 100}" v-show="codeShow">
        <img src="https://files.wondercv.com/download-code/editor-check.png" alt="">
        <section class="code-content">
          <span class="code-title">扫码下载 超级简历APP</span>
          <span class="code-description">简历在线修改，导出方便快捷，还有面试攻略等你挖掘</span>
        </section>
      </div> -->

      <!-- <div class="suggest-content center">
        <img src="https://files.wondercv.com/pcvue/zu.png" alt="">
        <p class="t">检查次数已用完，</p>
        <p>每日可以使用1次免费检查，</p>
        <p><b>升级会员</b>可全部优化建议</p>
        <button>查看简历问题</button>
      </div> -->

      <!-- 纠错模式下，功能不可用 -->
      <div class="open-resume-error-cover-up" v-show="openResumeError" @click.stop="showCloseResumeError()"></div>
    </div>
    <rename-modal v-if="renameShow" :cv-token="cvDetail.basic_info.token" :cv-name="cvDetail.basic_info.cv_name" @editCvName="editCvName" />
    <!-- 次数提示-提示框 -->
    <tips-block v-if="showUseCheckCvError"
      tipsTitle="温馨提示" confirmButtonText="使用" cancelButtonText="再想想"
      :tipsTextHtml="`您还剩余 <span class='color_red'>${resumeErrorInfo.remain_times}</span> 次简历纠错机会，确认使用吗？`"
      @confirmFunc="findCvErrors" @cancelFunc="showUseCheckCvError=false"
    />
    <!-- 取消提示-提示框 -->
    <tips-block v-if="showCloseCvErrorTips"
      tipsTitle="温馨提示" confirmButtonText="退出纠错" cancelButtonText="继续纠错"
      tipsText="再次进入需要重新检查，确定退出纠错模式吗？"
      @confirmFunc="closeCvErrors" @cancelFunc="showCloseCvErrorTips=false"
    />
  </div>
</template>
<script>
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
	import renameModal from '@/components/renameModal'
	import tipsBlock from '@/components/alert/tipsBlock'
	import { rules } from '@/assets/json/rules.json'
	import { addClass, removeClass, } from '@/assets/js/dom'
	import { dealResumeDomScroll } from '@/assets/js/util'

  import { get_tUser } from '@/assets/js/util'
  import { dealCvDataMixin, cvResumeErrorMixin } from '@/assets/js/mixins'
  import api from "@/api"
	const moment = require('moment')

	export default {
		name: 'optimize',
		props: {
			notMemberAgainCheck: {
				type: Boolean,
				default: false
			}
		},
    mixins: [dealCvDataMixin, cvResumeErrorMixin],
		data () {
			return {
				show: true,
				renameShow: false,
        cvModuleActive: false, // 控制简历认证模块是否展开
        resumeRecommend: false, // 控制简历推荐是否展开
        privacy: null, // 隐私设置
        mockInterviewList: [], //模拟面试模块展示
        mockInterviewLoadingText: '', //模拟面试加载中文案
        mockInterviewNotData: false, //是否没有数据

        showUseCheckCvError: false, //展开使用简历纠错提示
        showCloseCvErrorTips: false, //确认取消使用简历纠错提示
        getCvPortraitEnd: false,
        resumeToken: '', //简历token
        // filterErrorInfo: [], // 错误数据集合
        // selectErrorInfo: { //当前选中的错误信息
        //   position: {
        //     left: 0,
        //     right: 0,
        //   },
        //   modelPosition: null,
        //   modelData: null,
        //   isWrap: false,
        // },
			}
		},
		mounted () {
      let { token } = this.$route.params
      this.resumeToken = token

			this.dealSuggestions()
      this.getPersonPrivacy()
      // 获取简历分析
      // this.getCvPortrait(token)
      // 获取纠错信息
      this.getCvErrors(token);
      window.windowErrorTextChange = (values)=>{
        console.log('windowErrorTextChange=>>>>',values)
      }

      // 获取历史模拟面试结果
      // this.getMockInterviewData(token)
		},
		computed: {
			...mapState('editor', [ 'checkData', 'cvDetail', 'profile', 'edus', 'works', 'orgs', 'extras', 'score', 'readyScore', 'dealCheck', 'hasJobscanRepor', 'cvPortrait', 'resumeErrorInfo', 'resumeErrorFilterType', 'filterErrorInfo', 'selectErrorInfo', 'errorUuidList', 'openResumeError', 'useResumeError', 'isShowResumeErrorGuide' ]),
			...mapState('me', [ 'isMembership' ]),
      ...mapGetters('editor', ['getFilterErrorInfoSize']),
      // 简历画像风险点数量
      cvRisksLength () {
			  return this.cvPortrait.cv_risks ? this.cvPortrait.cv_risks.length : 0
      },
			suggestFields () {
				let list = [
					{
						field: 'profile',
						title: '基本信息',
						img: 'https://files.wondercv.com/cv-check/profile.png',
            active: false, // 是否展开
            perfectText: '必要信息均已填写💯' // 没有优化建议时展示的文本
					},
					{
						field: 'edus',
						title: '教育经历',
						img: 'https://files.wondercv.com/cv-check/edu.png',
            active: false,
            perfectText: '完美！无可挑剔的经历～'
					},
					{
						field: 'works',
						title: '工作经历',
						img: 'https://files.wondercv.com/cv-check/work.png',
            active: false,
            perfectText: '这工作经历，我给满分～'
					},
					{
						field: 'global_result',
						title: '专业细节',
            img: 'https://files.wondercv.com/cv-check/detail.png',
            active: false,
            perfectText: '无敌细节控，暂无可优化项～'
					},
					{
						field: 'others',
						title: '其他模块',
						img: 'https://files.wondercv.com/cv-check/other.png',
            active: false,
            perfectText: '暂无优化建议～'
					},
          {
						field: 'analyse',
						title: '简历分析',
						img: 'https://files.wondercv.com/cv-check/analysis.png',
            active: false,
            perfectText: '暂无分析结果～'
					},
				]
        // 如果没有简历推荐，再打开有错误的类型
        // if(!this.cvDetail.format_info.watermark){
        //   this.resumeRecommend = true;
        // }else{
          // 查找优化项并展开
          let key = Object.keys(this.checkData).filter(key => this.checkData[key].length > 0)
          list.forEach(item => {
            if(key.includes(item.field)) item.active = true
          })
        // }

        return list
			},
			totalCount () {
				let count = 0
				for (let key in this.checkData) {
					if (this.checkData[key] instanceof Array) count += this.checkData[key].length
				}
				return count
			},
			codeShow () {
				let state = false
				for (let k in this.checkData) {
					if (this.checkData[k].length) {
						state = true
						break
					}
				}
				return state || this.readyScore === 100
			},
      isMentorEditor () {
        return window.location.href.includes('mentor')
      }
		},
		components: {
			renameModal,
      tipsBlock
		},
		watch: {
			dealCheck (val) {
				if (val) this.dealSuggestions()
			},
			show: {
				handler (val) {
					this.$nextTick(() => {
						let el = document.querySelector('.side-info-bottom')
						if (val) {
							// setTimeout(() => {
							addClass(el, 'optimize-info')
							// }, 30)
						} else {
							removeClass(el, 'optimize-info')
						}
					})
				},
				immediate: true
			},
      // 监听是否购买成功纠错次数
      useResumeError(newValue){
        console.log(newValue)
        if(newValue){
          // 启动检查纠错
          this.findCvErrors();
          // 关闭启动纠错状态
          this.setUseResumeError(false)
        }
      },
		},
		methods: {
			...mapActions('editor', [ 'cvAutoSort', 'getCvPortrait' ]),
			...mapMutations('editor', [ 'setSuggestInfo', 'setCurrentInfo', 'setCheckData', 'setDealCheck', 'setShowWordNumHint', 'setResumeErrorInfo', 'setScannerState', 'setResumeErrorFilterType', 'setFilterErrorInfo', 'setSelectErrorInfo', 'setOpenResumeError', 'setErrorUuidList', 'setResumeErrorRemainTimes', 'setShowPurchasesErrorNumber', 'setUseResumeError', 'setResumeErrorItemInfo', 'setEditorMenuTipsType' ]),
			...mapMutations('experience', [ 'updateSidebarOption', 'setShowManageAddGuide']),
      // 获取在线简历数据
      async getPersonPrivacy() {
        let user = get_tUser()
        if (user && user.c_t) {
          // 获取隐私设置
          try {
            let res = await api.account.getPersonPrivacy(user.c_t);
            if (res.code === 1000) {
              // console.log(res.data,"=====>privacy");
              this.privacy = res.data
            } else {
              this.$message.error(res.message);
            }
          } catch (e) {
            console.error(e);
          }
        }
      },
      // 优化建议模块 展开和收起
      toggleStatus (data) {
        data.active = !data.active
        this.$forceUpdate()
        if(data.field === 'analyse' && !this.getCvPortraitEnd){
          this.getCvPortraitEnd = true
          let { token } = this.$route.params
          this.getCvPortrait(token)
        }
        // const { field, active } = data
        // const checkContent = this.$refs[`${field}&checkContent`][0]
        // console.log(field, active, checkContent.width)
      },
      nothing () {},
      toBlogDetail (e) {
	      e.stopPropagation()
      },
			// 点击在编辑页定位到位置并且高亮
			async suggestDetail (val, item) {
        if (val.desc === '简历中最好要有至少1段组织或者活动经历，建议添加' || val.desc === '工作经历应该作为简历的主体内容，目前这部分篇幅和其他内容相比较少，建议再增加一些工作经历内容，或者删减其他部分内容' || val.desc === '教育经历是简历上的必填信息，请添加教育经历模块') {
          this.setEditorMenuTipsType('addModule')
          return
        }
				let detail = val.highlights[0] || {}, rule
				if (val.name) rule = rules.filter(item => item.name === val.name)[0]
        // if (val.name === 'no_work?') {
	      //   this.updateSidebarOption('manage')
        // } else
        if (val.name === 'cv_name?') {
					this.renameShow = true
				} else if (val.name === 'latest_not_first?') {
					if (!val.hasChange) this.cvAutoSort(true)
				} else if (item.field === 'profile' && detail) {
					let suggestInfo = { field: detail.field, errorName: rule.title, errorDescription: val.desc, suggest: true }
					this.setSuggestInfo(suggestInfo)
					this.updateSidebarOption('')
					this.setCurrentInfo({
						type: 'profile',
						operation: 'edit',
						data: this.profile
					})
				} else if (detail && detail.whole_section) {
          if (val.name === 'too_little_word?'){
            this.setShowWordNumHint(true)
            return
          }
					// let el = document.getElementById(detail.section)
					let stringEl = `.${ detail.section }`
					let els = document.querySelectorAll(stringEl)
					if (els && els.length) {
						this._dealElScroll(els)
					} else {
						this.updateSidebarOption('manage')
            this.setShowManageAddGuide(true)
            setTimeout(()=>{
              this.setShowManageAddGuide(false)
            },5000)
					}
				} else if ((item.field === 'edus' || item.field === 'works' || item.field === 'orgs') && detail) {
					let suggestInfo = {
						field: detail.field === 'start_at' || detail.field === 'end_at' ? 'datetime' : detail.field,
						errorName: rule.title,
						errorDescription: val.desc,
						suggest: true
					}
					this.setSuggestInfo(suggestInfo)
					const index = this[item.field].findIndex(val => val.id === detail.section_id)
					this.updateSidebarOption('')
					this.setCurrentInfo({
						type: item.field,
						operation: 'edit',
						data: this[item.field][index],
						title: this.cvDetail.submodule_info[`${ item.field }_title`]
					})
				} else if (item.field === 'global_result' && detail) {
					if (val.name === 'line_item_more_than?') {
						let stringEl = `.section-${ detail.section_id }`
						this._dealElScroll(document.querySelectorAll(stringEl))
					}  else if (detail) {
						let suggestInfo = {
							errorName: rule.title,
							errorDescription: val.desc,
							suggest: true,
							highlight: detail.highlight,
							highlightSave: true
						}
						this.setSuggestInfo(suggestInfo)
						const infos = detail.section === 'custom' ? this.$store.state.editor[detail.section_id] : this.$store.state.editor[detail.section]
						const index = infos.findIndex(item => item.id === detail.section_id || item.id === detail.section_info_id)
						this.updateSidebarOption('')
						this.setCurrentInfo({
							type: detail.section === 'custom' ? detail.section_id : detail.section,
							operation: 'edit',
							data: infos[index],
							title: infos[index].custom_section_id ?
								this.cvDetail.submodule_info.custom_sections_titles[`${ infos[index].custom_section_id }_title`] :
								this.cvDetail.submodule_info[`${ detail.section }_title`]
						})
					}
					// else {
					// 	let suggestInfo = { field: detail.field, errorName: rule.title, errorDescription: val.desc, suggest: true }
					// 	this.setSuggestInfo(suggestInfo)
					// 	const infos = detail.section === 'custom' ? this.$store.state.editor[detail.section_id] : this.$store.state.editor[detail.section]
					// 	const index = infos.findIndex(item => item.id === detail.section_id)
					// 	this.setCurrentInfo({
					// 		type: detail.section === 'custom' ? detail.section_id : detail.section,
					// 		operation: 'edit',
					// 		data: infos[index]
					// 	})
					// }
				} else if (item.field === 'others') {
        	let { submodule_info: { sections_position } } = this.cvDetail
					let errorName = val.name === 'languages_blank?' ? '添加语言能力' : val.name === 'skills_blank?' ? '建议添加技能' : ''
					let field = val.name === 'languages_blank?' ? 'language' : val.name === 'skills_blank?' ? 'skill' : ''
					let suggestInfo = { errorName, field, errorDescription: val.desc, suggest: true }
					this.setSuggestInfo(suggestInfo)
					this.updateSidebarOption('')
          const index  = sections_position.findIndex(item => item.type === 'extras')
          const data = {
            skill: {
              name: '技能',
              description: null
            },
            language: {
              name: '语言',
              description:null
            },
            other: {
              name: '活动',
              description:null
            },
            interest: {
              name: '兴趣',
              description:null
            },
            certificate: {
              name: '证书/执照',
              description:null
            }
          }
          if (index === -1) {
	          this.$store.state.editor.extras = data
	          sections_position.push({
		          type: 'extras',
		          id: null,
		          info_ids: []
	          })
          }
					this.setCurrentInfo({
						type: 'extras',
						operation: index === -1 ? 'module' : 'edit',
						data: { ...data, ...this.extras },
						title: this.cvDetail.submodule_info.extras_title
					})
          this.$nextTick(() => {
            const scrollEl = document.querySelector('.cvs-component')
            let moduleEls = document.querySelectorAll('.extras')
            if (moduleEls && moduleEls.length) {
              scrollEl.scrollTo({ top: moduleEls[0].offsetTop - 180, behavior: 'smooth' })
            }
          })
				}
			},
			// 非会员初始化建议
			dealSuggestions () {
				try {
					let { basic_info: { token } } = this.cvDetail
					let localSuggest = JSON.parse(localStorage.getItem(`${ token }-checkData`))
					let newSuggestions = JSON.parse(JSON.stringify(this.checkData))
					if (!this.isMembership && localSuggest) {
						for (let key in localSuggest) {
							if (localSuggest[key] instanceof Array) {
								localSuggest[key].forEach(item => {
									const index = newSuggestions[key] ? newSuggestions[key].findIndex(val => val.name === item.name) : -1
									if (index === -1) {
										item.hasChange = true
									} else {
										let values = this.contrastData(item.highlights, newSuggestions[key][index].highlights)
										item.highlights = values || item.highlights
										if (values && !values.length) item.hasChange = true
									}
								})
							}
						}
						this.setCheckData({ score: this.score, suggestions: localSuggest })
						this.setDealCheck(false)
					}
				} catch (e) {
          console.error(e)
				}
			},
			// 对比两个highLight数组中的相同和不同的数据
			contrastData (oldVal, newVal) {
				return oldVal.filter(item => {
					return newVal.findIndex(val => val.section_id === item.section_id) > -1
				})
			},
			// 处理dom高亮整个模块
			_dealElScroll (els) {
				const scrollEl = document.querySelector('.cvs-component')
				if (this.preDom && this.preDom.length) {
					for (let i = 0; i < els.length; i++) {
						removeClass(els[i], 'high-light-error')
					}
				}
				if (els && els.length) {
					this.$emit('handleClose')
					for (let i = 0; i < els.length; i++) {
						addClass(els[i], 'high-light-error')
						this.preDom = els
					}
					let { pageIndex, pageElHeight } = dealResumeDomScroll(els)
					this.$emit('dealCheckDomScroll', { pageIndex, pageElHeight })
					scrollEl.scrollTo({ top: els[0].offsetTop - 130, behavior: 'smooth' })
				}
				// if (els && els.length && els !== this.preDom) {
				// 	this.$emit('handleClose')
				// 	if (this.preDom) removeClass(this.preDom, 'high-light-error')
				// 	addClass(el, 'high-light-error')
				// 	this.$nextTick(() => {
				// 		scrollEl.scrollTo({ behavior: 'smooth', top: el.offsetTop })
				// 		this.preDom = el
				// 	})
				// } else {
				// 	// this.showToast('该建议已失效', 1500)
				// }
			},
			// 更改cvName
			editCvName (name) {
				this.renameShow = false
			},
			changeDownloadAppState () {
				this.$emit('changeDownloadAppState')
      },


      // 获取纠错信息
      getCvErrors(token){
        if(!token) return
        api.cvError.getCvErrors({
          cv_token: token,
          type: 'cv'
        }).then(res=>{
          if(res.code === 1000){
            // 同步纠错信息
            this.setResumeErrorInfo(res.data)
            // 启动纠错
            // setTimeout(() => {
            //   this.changeResumeErrorCorrection();
            // }, 5000);
          }
        })
      },
      // 点击纠错，检查是否还有次数
      async checkCvErrors(){
        console.log(this.resumeErrorInfo)
        // 每次查询都重新获取一些次数
        let { token } = this.$route.params
        let res = await api.cvError.getCvErrors({
          cv_token: token,
          type: 'cv'
        })
        if(res.code === 1000){
          // 同步纠错信息
          this.setResumeErrorRemainTimes(res.data.remain_times)
        }

        // 有次数弹出使用弹窗，没次数弹出购买弹窗
        if(this.resumeErrorInfo.remain_times > 0){
          this.showUseCheckCvError = true;
        }else{
          // 打开购买弹窗
          this.setShowPurchasesErrorNumber(true)
          console.log('没次数')
        }
      },
      // 查询纠错信息
      findCvErrors(){
        let { basic_info: { token } } = this.cvDetail;
        // 关闭确认弹窗
        this.showUseCheckCvError = false;
        // 打开扫描样式
        this.setScannerState(true)
        api.cvError.findCvErrors({
          cv_token: token,
          type: 'cv'
        }).then(res=>{
          // 关闭扫描样式
          this.setScannerState(false)
          if(res.code === 1000){
            // 同步纠错信息
            this.setResumeErrorInfo(res.data)
            // 启动纠错
            this.changeResumeErrorCorrection();
          }
        })
      },
      // 关闭纠错模式
      closeCvErrors(){
        // 关闭确认弹窗
        this.showCloseCvErrorTips=false;
        // 启动纠错模式
        this.setOpenResumeError(false)
        // 清除数据
        document.querySelectorAll('.matchTipsContent').forEach(domItem=>{
          domItem.innerHTML = ''
        })
        // 取消弹窗数据
        this.setSelectErrorInfo(null)
      },
      // 去买会员
      buyMember(){
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip',
          browseType: 'suggestion'
        })
      },


      /**
       * 模拟面试方法
       */
      // 获取历史面试结果
      // getMockInterviewData(cvToken){
      //   api.cvsV3.getMockInterview(cvToken).then(res => {
      //     if(res.code === 1000){
      //       let { result } = res.data
      //       if(result.length){

      //       }
      //     }
      //   })
      // },
      // 获取最新面试结果
      async checkMockInterview() {

        // 20230724替换获取面试结果逻辑为跳转导师辅导落地页
        // window && window.open(`https://www.wondercv.com/service/`);
        // return false;
        
        this.mockInterviewList = []
        this.mockInterviewLoadingText = '正在分析简历内容'
        this.mockInterviewNotData = false
        let timer = setTimeout(() => {
          this.mockInterviewLoadingText = '正在生成面试问题'
        }, 8 * 1000);
        // let dom = document.querySelector('.optimize-main .optimize-content')
        // if(!!dom){
        //   setTimeout(() => {
        //     dom.scrollTo(0, 5000)
        //   }, 500);
        // }
        try {
          let res = await api.cvsV3.sendMockInterview(this.resumeToken);
          if(res.code === 1000){
            let { result } = res.data
            if(result.length){
              this.mockInterviewList =  result.split('\n').filter(item => {return !!item && item.length > 5 })
              if(!!dom){
                setTimeout(() => {
                  dom.scrollTo(0, 5000)
                }, 500);
              }
            }
          }
        } catch (error) {
        }

        clearTimeout(timer)
        this.mockInterviewLoadingText = '' //清空loading状态
        this.mockInterviewNotData = !this.mockInterviewList.length //是否没有数据
      },
      toService(){
        window.open(`${location.origin}/service`)
      },
		}
	}
</script>
<style lang="scss" scoped>
  @import './optimize.scss';
</style>
<style lang="scss">
  .article-tooltip-container-1 {
    background: #505667 !important;
    margin-left: -6px;
    .article-content {
      color: #FFffff;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        font-weight: 600;
      }
    }
    .popper__arrow::after {
      border-bottom-color: #505667 !important;
    }
  }

</style>
